import { GfsOfferListPage } from "@/services/backend/gfs/offer/components/offer-list-page";

export default function GfsOffersIndexRoute() {
  return <GfsOfferListPage />;
}
